import { gql } from "@apollo/client";

/**
 * @deprecated Shared fragments are deprecated. Indicate field name directly within query/mutation or
 * create a co-located (not shared) fragment, if you need one.
 */
const CERTIFICATION_FRAGMENT = gql`
  fragment CertificationFragment on Certification {
    id

    name
    certificationUrl
    currentState
    createdAt
    updatedAt
  }
`;

/**
 * @deprecated Shared fragment types are deprecated. Use or pick from generated types instead.
 */
interface CertificationFragment {
  id: string;
  name: string;
  certificationUrl: string;
  currentState: string;
  createdAt: string;
  updatedAt: string;
}

export type { CertificationFragment };
export { CERTIFICATION_FRAGMENT };
